export default __webpack_public_path__ + "static/media/premium.79153de3.png";